// @generated by protobuf-ts 2.11.1 with parameter server_generic,client_generic,generate_dependencies
// @generated from protobuf file "devices/v1/service.proto" (package "devices.v1", syntax proto3)
// tslint:disable
import { DeviceModelService } from "./service.js";
import { DeviceService } from "./service.js";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * Device Management Service
 *
 * @generated from protobuf service devices.v1.DeviceService
 */
export class DeviceServiceClient {
    _transport;
    typeName = DeviceService.typeName;
    methods = DeviceService.methods;
    options = DeviceService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * Device CRUD operations
     *
     * @generated from protobuf rpc: CreateDevice
     */
    createDevice(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single device by its unique identifier
     *
     * @generated from protobuf rpc: GetDevice
     */
    getDevice(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists devices with optional filtering, pagination, and sorting
     *
     * @generated from protobuf rpc: ListDevices
     */
    listDevices(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing device with partial or full field updates
     *
     * @generated from protobuf rpc: UpdateDevice
     */
    updateDevice(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a device either permanently or with soft delete
     *
     * @generated from protobuf rpc: DeleteDevice
     */
    deleteDevice(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Restores a previously soft-deleted device
     *
     * @generated from protobuf rpc: RestoreDevice
     */
    restoreDevice(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves enrichment data for telemetry (static fields like device_type, site_id, power limits)
     *
     * @generated from protobuf rpc: GetDeviceEnrichmentData
     */
    getDeviceEnrichmentData(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Batch variant of GetDeviceEnrichmentData for fleet-wide hydration.
     * Returns one enrichment entry per resolvable device_id (unresolvable ids are omitted).
     *
     * @generated from protobuf rpc: BatchGetDeviceEnrichmentData
     */
    batchGetDeviceEnrichmentData(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Device Default Profile CRUD
     *
     * @generated from protobuf rpc: SetDeviceDefaultProfile
     */
    setDeviceDefaultProfile(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * GetDeviceDefaultProfile returns the active default charging profile for a device, or an empty response if none is set.
     *
     * @generated from protobuf rpc: GetDeviceDefaultProfile
     */
    getDeviceDefaultProfile(input, options) {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteDeviceDefaultProfile soft-deletes the active default charging profile and dispatches a ClearChargingProfile command to the device.
     *
     * @generated from protobuf rpc: DeleteDeviceDefaultProfile
     */
    deleteDeviceDefaultProfile(input, options) {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * ListDeviceDefaultProfileHistory returns the audit history of default profile changes for a device in reverse chronological order.
     *
     * @generated from protobuf rpc: ListDeviceDefaultProfileHistory
     */
    listDeviceDefaultProfileHistory(input, options) {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Station CRUD operations
     *
     * @generated from protobuf rpc: CreateStation
     */
    createStation(input, options) {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single charging station by its unique identifier
     *
     * @generated from protobuf rpc: GetStation
     */
    getStation(input, options) {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists charging stations with optional location filtering, pagination, and sorting
     *
     * @generated from protobuf rpc: ListStations
     */
    listStations(input, options) {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing charging station with partial or full field updates
     *
     * @generated from protobuf rpc: UpdateStation
     */
    updateStation(input, options) {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a charging station either permanently or with soft delete
     *
     * @generated from protobuf rpc: DeleteStation
     */
    deleteStation(input, options) {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * EVSE CRUD operations
     *
     * @generated from protobuf rpc: CreateEvse
     */
    createEvse(input, options) {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single EVSE (Electric Vehicle Supply Equipment) by its unique identifier
     *
     * @generated from protobuf rpc: GetEvse
     */
    getEvse(input, options) {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists EVSEs with optional station filtering, pagination, and sorting
     *
     * @generated from protobuf rpc: ListEvses
     */
    listEvses(input, options) {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing EVSE with partial or full field updates
     *
     * @generated from protobuf rpc: UpdateEvse
     */
    updateEvse(input, options) {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes an EVSE either permanently or with soft delete
     *
     * @generated from protobuf rpc: DeleteEvse
     */
    deleteEvse(input, options) {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Connector CRUD operations
     *
     * @generated from protobuf rpc: CreateConnector
     */
    createConnector(input, options) {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single connector by its unique identifier
     *
     * @generated from protobuf rpc: GetConnector
     */
    getConnector(input, options) {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists connectors with optional EVSE filtering, pagination, and sorting
     *
     * @generated from protobuf rpc: ListConnectors
     */
    listConnectors(input, options) {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing connector with partial or full field updates
     *
     * @generated from protobuf rpc: UpdateConnector
     */
    updateConnector(input, options) {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a connector either permanently or with soft delete
     *
     * @generated from protobuf rpc: DeleteConnector
     */
    deleteConnector(input, options) {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Battery CRUD operations
     *
     * @generated from protobuf rpc: CreateStationaryBattery
     */
    createStationaryBattery(input, options) {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single stationary battery by its unique identifier
     *
     * @generated from protobuf rpc: GetStationaryBattery
     */
    getStationaryBattery(input, options) {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists stationary batteries with optional site and deployment status filtering
     *
     * @generated from protobuf rpc: ListStationaryBatteries
     */
    listStationaryBatteries(input, options) {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing stationary battery with partial or full field updates
     *
     * @generated from protobuf rpc: UpdateStationaryBattery
     */
    updateStationaryBattery(input, options) {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a stationary battery either permanently or with soft delete
     *
     * @generated from protobuf rpc: DeleteStationaryBattery
     */
    deleteStationaryBattery(input, options) {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Device Error operations
     *
     * @generated from protobuf rpc: CreateDeviceError
     */
    createDeviceError(input, options) {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single device error by its unique identifier
     *
     * @generated from protobuf rpc: GetDeviceError
     */
    getDeviceError(input, options) {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists device errors with optional filtering by device, criticality, and resolution status
     *
     * @generated from protobuf rpc: ListDeviceErrors
     */
    listDeviceErrors(input, options) {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Marks a device error as resolved with optional resolution details
     *
     * @generated from protobuf rpc: ResolveDeviceError
     */
    resolveDeviceError(input, options) {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
/**
 * Device Model Management Service
 *
 * @generated from protobuf service devices.v1.DeviceModelService
 */
export class DeviceModelServiceClient {
    _transport;
    typeName = DeviceModelService.typeName;
    methods = DeviceModelService.methods;
    options = DeviceModelService.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * Station Model CRUD operations
     *
     * @generated from protobuf rpc: CreateStationModel
     */
    createStationModel(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single station model configuration by its unique identifier
     *
     * @generated from protobuf rpc: GetStationModel
     */
    getStationModel(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists station models with optional manufacturer and protocol filtering
     *
     * @generated from protobuf rpc: ListStationModels
     */
    listStationModels(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing station model configuration
     *
     * @generated from protobuf rpc: UpdateStationModel
     */
    updateStationModel(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a station model configuration
     *
     * @generated from protobuf rpc: DeleteStationModel
     */
    deleteStationModel(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * EVSE Model CRUD operations
     *
     * @generated from protobuf rpc: CreateEvseModel
     */
    createEvseModel(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single EVSE model configuration by its unique identifier
     *
     * @generated from protobuf rpc: GetEvseModel
     */
    getEvseModel(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists EVSE models with optional manufacturer filtering
     *
     * @generated from protobuf rpc: ListEvseModels
     */
    listEvseModels(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing EVSE model configuration
     *
     * @generated from protobuf rpc: UpdateEvseModel
     */
    updateEvseModel(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes an EVSE model configuration
     *
     * @generated from protobuf rpc: DeleteEvseModel
     */
    deleteEvseModel(input, options) {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Connector Model CRUD operations
     *
     * @generated from protobuf rpc: CreateConnectorModel
     */
    createConnectorModel(input, options) {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single connector model configuration by its unique identifier
     *
     * @generated from protobuf rpc: GetConnectorModel
     */
    getConnectorModel(input, options) {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists connector models with optional manufacturer and connector type filtering
     *
     * @generated from protobuf rpc: ListConnectorModels
     */
    listConnectorModels(input, options) {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing connector model configuration
     *
     * @generated from protobuf rpc: UpdateConnectorModel
     */
    updateConnectorModel(input, options) {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a connector model configuration
     *
     * @generated from protobuf rpc: DeleteConnectorModel
     */
    deleteConnectorModel(input, options) {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Battery Model CRUD operations
     *
     * @generated from protobuf rpc: CreateStationBatteryModel
     */
    createStationBatteryModel(input, options) {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single station battery model configuration by its unique identifier
     *
     * @generated from protobuf rpc: GetStationBatteryModel
     */
    getStationBatteryModel(input, options) {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists station battery models with optional manufacturer and protocol filtering
     *
     * @generated from protobuf rpc: ListStationBatteryModels
     */
    listStationBatteryModels(input, options) {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing station battery model configuration
     *
     * @generated from protobuf rpc: UpdateStationBatteryModel
     */
    updateStationBatteryModel(input, options) {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a station battery model configuration
     *
     * @generated from protobuf rpc: DeleteStationBatteryModel
     */
    deleteStationBatteryModel(input, options) {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Communication Protocol operations
     *
     * @generated from protobuf rpc: CreateCommunicationProtocol
     */
    createCommunicationProtocol(input, options) {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing communication protocol
     *
     * @generated from protobuf rpc: UpdateCommunicationProtocol
     */
    updateCommunicationProtocol(input, options) {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists available communication protocols with optional pagination
     *
     * @generated from protobuf rpc: ListCommunicationProtocols
     */
    listCommunicationProtocols(input, options) {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a communication protocol
     *
     * @generated from protobuf rpc: DeleteCommunicationProtocol
     */
    deleteCommunicationProtocol(input, options) {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Device Error Type operations
     *
     * @generated from protobuf rpc: CreateDeviceErrorType
     */
    createDeviceErrorType(input, options) {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Retrieves a single device error type definition by its unique identifier
     *
     * @generated from protobuf rpc: GetDeviceErrorType
     */
    getDeviceErrorType(input, options) {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists device error type definitions with optional device model and criticality filtering
     *
     * @generated from protobuf rpc: ListDeviceErrorTypes
     */
    listDeviceErrorTypes(input, options) {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing device error type definition
     *
     * @generated from protobuf rpc: UpdateDeviceErrorType
     */
    updateDeviceErrorType(input, options) {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a device error type definition
     *
     * @generated from protobuf rpc: DeleteDeviceErrorType
     */
    deleteDeviceErrorType(input, options) {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Control Signal Type operations
     * Creates a new control signal type
     *
     * @generated from protobuf rpc: CreateControlSignalType
     */
    createControlSignalType(input, options) {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Lists control signal types with optional device model filtering and pagination
     *
     * @generated from protobuf rpc: ListControlSignalTypes
     */
    listControlSignalTypes(input, options) {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Updates an existing control signal type
     *
     * @generated from protobuf rpc: UpdateControlSignalType
     */
    updateControlSignalType(input, options) {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a control signal type
     *
     * @generated from protobuf rpc: DeleteControlSignalType
     */
    deleteControlSignalType(input, options) {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
//# sourceMappingURL=service.client.js.map